(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("point-cloud-classification", [], factory);
	else if(typeof exports === 'object')
		exports["point-cloud-classification"] = factory();
	else
		root["point-cloud-classification"] = factory();
})(self, function() {
return 